import React from "react"
import { useSiteMetadata } from "../hooks/use-site-metadata.js"

export default function StructuredDataWebpage({
  newURL,
  path, // must include the leading slash
  name,
  description,
  breadcrumbItems,
  primaryImageOfPage,
  image,
  thumbnailUrl,
}) {

  const data = useSiteMetadata()
  const url = newURL || data.siteUrl
  let primaryImage = {
    "@id": `${url}#primaryimage`
  }
  let img = {
    "@id": `${url}#primaryimage`
  }

  if (data.image) {
    primaryImage = data.image
    img = data.image
  }

  if (primaryImageOfPage) {
    primaryImage = primaryImageOfPage
  }

  if (image) {
    img = image
  }

  const schemaOrgWebPage = {
    "@context": "https://schema.org",
    "@graph": [
      {
        "@type": "WebPage",
        "@id": `${url}${path}`,
        "url": `${url}${path}`,
        "name": name,
        "description": description,
        "isPartOf": {
          "@id": `${url}#website`
        },
        "about": {
          "@id": `${url}#organization`
        },
        "primaryImageOfPage": primaryImage,
        "image": img,
        "thumbnailUrl": thumbnailUrl || `${url}#primaryimage`,
        "breadcrumb": {
          "@id": `${url}#breadcrumb`
        },
        "potentialAction": [
          {
            "@type": "ReadAction",
            "target": [
              `${url}${path}`
            ]
          }
        ]
      },
      {
        "@type": "BreadcrumbList",
        "@id": `${url}#breadcrumb`,
        "itemListElement": breadcrumbItems.map((item, index) => ({
          "@type": "ListItem",
          "position": index + 1,
          "item": {
            "@id": `${url}${path}`,
            "name": item
          }
        }))
      }
    ]
  }

  return (
    <script type="application/ld+json">
      {JSON.stringify(schemaOrgWebPage)}
    </script>
  )
}